import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

const inputWrapper = {
  height: {
    iphone: 50,
  },
};

export const InputFieldStyle = styled.div`
  width: 100%;

  &.with-instructions {
    .input-wrapper {
      margin-bottom: 4px;

      & ~ .input-instructions {
        padding: 0 20px 0 56px;
      }
    }
  }

  &.no-margin-bottom {
    .input-wrapper {
      margin-bottom: 0;
    }
  }

  &.no-icon {
    .input-wrapper {
      padding: 0 20px;
    }
  }

  &.rounded-shape {
    .input-wrapper {
      border-radius: 8px;
    }
  }

  &.circle-shape {
    .input-wrapper {
      border-radius: ${inputWrapper.height.iphone / 2}px;
    }
  }

  &.square-shape {
    .input-wrapper {
      border-radius: 0;
    }
  }

  &.error-theme,
  &.with-error {
    .input-wrapper {
      border: 1px solid ${colors.softRed};
      margin-bottom: 0;

      &.with-instructions {
        margin-bottom: 0;
      }

      .input-icon {
        svg {
          fill: ${colors.softRed};
        }
      }
    }
  }

  .input-wrapper {
    align-items: center;
    background-color: ${colors.white};
    border: 1px solid ${colors.grayishBlue};
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
    min-height: ${inputWrapper.height.iphone}px;
    overflow: hidden;
    padding: 0 20px 0 56px;
    position: relative;

    .input-element {
      ${fontFamily.InputFieldStyle};
      border: none;
      color: ${colors.veryDarkGray};
      display: block;
      font-size: 14px;
      line-height: 20px;
      padding: 12px 0 14px;
      width: 100%;

      &:disabled {
        background-color: transparent;
        cursor: not-allowed;
      }
    }

    .input-icon {
      align-items: center;
      display: flex;
      height: 20px;
      justify-content: center;
      left: 20px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;

      svg {
        display: block;
        fill: ${colors.grayishBlue};
        height: auto;
        margin: 0 auto;
        max-height: 100%;
        max-width: 100%;
        width: auto;
      }
    }
  }

  .input-instructions {
    ${fontFamily.InputFieldStyle};
    background: transparent;
    border: none;
    color: ${colors.veryDarkGray};
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 12px;
  }

  .input-error {
    ${fontFamily.InputFieldStyle};
    background: transparent;
    border: none;
    color: ${colors.softRed};
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
`;
